import { representation_item } from "./index.js";
import { amount_of_substance_measure } from "./index.js";
import { area_measure } from "./index.js";
import { celsius_temperature_measure } from "./index.js";
import { context_dependent_measure } from "./index.js";
import { count_measure } from "./index.js";
import { descriptive_measure } from "./index.js";
import { electric_current_measure } from "./index.js";
import { length_measure } from "./index.js";
import { luminous_intensity_measure } from "./index.js";
import { mass_measure } from "./index.js";
import { numeric_measure } from "./index.js";
import { non_negative_length_measure } from "./index.js";
import { parameter_value } from "./index.js";
import { plane_angle_measure } from "./index.js";
import { positive_length_measure } from "./index.js";
import { positive_plane_angle_measure } from "./index.js";
import { positive_ratio_measure } from "./index.js";
import { ratio_measure } from "./index.js";
import { solid_angle_measure } from "./index.js";
import { thermodynamic_temperature_measure } from "./index.js";
import { time_measure } from "./index.js";
import { volume_measure } from "./index.js";
import { derived_unit } from "./index.js";
import { named_unit } from "./index.js";
/* This is generated code, don't modify */
import EntityTypesAP214 from "./entity_types_ap214.gen.js";
///**
// *  */
export class measure_representation_item extends representation_item {
    get type() {
        return EntityTypesAP214.MEASURE_REPRESENTATION_ITEM;
    }
    get value_component() {
        if (this.value_component_ === void 0) {
            const value = this.extractReference(1, false);
            if (!(value instanceof amount_of_substance_measure) && !(value instanceof area_measure) && !(value instanceof celsius_temperature_measure) && !(value instanceof context_dependent_measure) && !(value instanceof count_measure) && !(value instanceof descriptive_measure) && !(value instanceof electric_current_measure) && !(value instanceof length_measure) && !(value instanceof luminous_intensity_measure) && !(value instanceof mass_measure) && !(value instanceof numeric_measure) && !(value instanceof non_negative_length_measure) && !(value instanceof parameter_value) && !(value instanceof plane_angle_measure) && !(value instanceof positive_length_measure) && !(value instanceof positive_plane_angle_measure) && !(value instanceof positive_ratio_measure) && !(value instanceof ratio_measure) && !(value instanceof solid_angle_measure) && !(value instanceof thermodynamic_temperature_measure) && !(value instanceof time_measure) && !(value instanceof volume_measure)) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.value_component_ = value;
        }
        return this.value_component_;
    }
    get unit_component() {
        if (this.unit_component_ === void 0) {
            const value = this.extractReference(2, false);
            if (!(value instanceof derived_unit) && !(value instanceof named_unit)) {
                throw new Error("Value in STEP was incorrectly typed for field");
            }
            this.unit_component_ = value;
        }
        return this.unit_component_;
    }
    constructor(localID, internalReference, model) {
        super(localID, internalReference, model);
    }
}
measure_representation_item.query = [EntityTypesAP214.MEASURE_REPRESENTATION_ITEM];
measure_representation_item.expectedType = EntityTypesAP214.MEASURE_REPRESENTATION_ITEM;
